<!-- body wrapper  -->
<div class="body-wrapper">

    <!-- ==========page banner ========== -->
    <div class="page-ban">
        <div class="page-ban-inner">
            <div class="container">
                <div class="page-content">
                    <h2 class="page-title">
                        Contact
                    </h2>
                    <div class="page-url">
                        <a href="index-2.html" class="old-page">Home </a> /
                        <p>Contact</p>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <!-- ==========page banner end ====== -->
    <!-- ============Contact ======== -->
    <div class="contact cpy-8">
        <div class="container">
            <div class="row mb-5">
                <div class="col-md-6 mb-4">
                    <div class="form-content">
                        <h2 class="form-title">
                            GET IN TOUCH
                        </h2>
                        <p>Please add your details in the form below and our representative will get back to you as soon
                            as possible.</p>

                        <div class="contact-form mt-4">
                            <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
                                <div class="row">
                                    <div class="col-sm-6 my-2">
                                        <div class="input-container">
                                            <input id="first-name" class="form-control" type="text" pattern=".+"
                                                formControlName="first_name" required />
                                            <label class="label" for="first-name">First Name</label>
                                            <div *ngIf="submitted && con['first_name'].errors"
                                                class="abs-error text-danger">
                                                <div *ngIf="con['first_name'].errors['required']">First Name is required
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 my-2">
                                        <div class="input-container">
                                            <input id="Last-name" class="form-control" type="text" pattern=".+"
                                                formControlName="last_name" required />
                                            <label class="label" for="Last-name">Last Name</label>
                                            <div *ngIf="submitted && con['last_name'].errors"
                                                class="abs-error text-danger">
                                                <div *ngIf="con['last_name'].errors['required']">Last Name is required
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 my-2">
                                        <div class="input-container">
                                            <input id="email" class="form-control" type="email" pattern=".+" required
                                                formControlName="email" />
                                            <label class="label" for="email">Your Email</label>
                                            <div *ngIf="submitted && con['email'].errors" class="abs-error text-danger">
                                                <div *ngIf="con['email'].errors['required']">Email is required</div>
                                                <div *ngIf="con['email'].errors['pattern']">Please enter a valid email
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 my-2">
                                        <div class="input-container">
                                            <input id="phone" class="form-control" type="text" pattern=".+" required
                                                formControlName="phone" (keypress)="numberOnly($event)" />
                                            <label class="label" for="phone">Phone Number</label>
                                            <div *ngIf="submitted && con['phone'].errors" class="abs-error text-danger">
                                                <div *ngIf="con['phone'].errors['required']">
                                                    Phone number is required
                                                </div>
                                                <div *ngIf="con['phone'].errors['minlength']">
                                                    Minimum 10 numbers required
                                                </div>
                                                <div *ngIf="con['phone'].errors['maxlength']">
                                                    Maximum 10 numbers required
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 my-2">
                                        <div class="input-container">
                                            <input id="subject" class="form-control" type="text" pattern=".+" required
                                                formControlName="subject" />
                                            <label class="label" for="subject">Subject</label>
                                            <div *ngIf="submitted && con['subject'].errors"
                                                class="abs-error text-danger">
                                                <div *ngIf="con['subject'].errors['required']">Subject is required</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 my-2">
                                        <div class="input-container">
                                            <textarea name="message" id="message" class="form-control" rows="5" required
                                                formControlName="message"></textarea>
                                            <label class="label" for="message">Message</label>
                                            <div *ngIf="submitted && con['message'].errors"
                                                class="abs-error text-danger">
                                                <div *ngIf="con['message'].errors['required']">Message is required</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 mt-3">
                                        <button type="submit" class="custom-btn">Send
                                            Message</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 mt-1">
                    <div class="map-address">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3673.2893512100823!2d72.62030731496691!3d22.97638498497644!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x79278c7784ee2d0f!2sPrism+Textile+Machinery+Pvt.+Ltd.!5e0!3m2!1sen!2sin!4v1536749935387"
                            height="475" style="border:0;" allowfullscreen="" loading="lazy"
                            referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                    <h2 class="form-title">Contact Info</h2>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                    <div class="conatct-info-bottom h-100">
                        <div class="contact-header p-3">
                            <h5 class="division-heading fw-semibold text-uppercase mb-0">Our Office</h5>
                        </div>
                        <div class="contact-body p-3">
                            <div class="table-responsive">
                                <table class="table table-borderless table-sm mb-0">
                                    <tbody>
                                        <tr>
                                            <th class="text-black font-16">Street:</th>
                                            <td>Plot No. 84/1, Phase I, G.I.D.C., Vatva</td>
                                        </tr>
                                        <tr>
                                            <th class="text-black font-16">City:</th>
                                            <td>Ahmedabad - 382445</td>
                                        </tr>
                                        <tr>
                                            <th class="text-black font-16">Country:</th>
                                            <td>Gujarat, India</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                    <div class="conatct-info-bottom h-100">
                        <div class="contact-header p-3">
                            <h5 class="division-heading fw-semibold text-uppercase mb-0">SALES & MARKETING DEVISION</h5>
                        </div>
                        <div class="contact-body p-3">
                            <div class="table-responsive">
                                <table class="table table-borderless table-sm mb-0">
                                    <tbody>
                                        <tr>
                                            <th class="text-black font-16">Managing Director:</th>
                                            <td><a class="theme-color" href="tel:+919825190401">+919825190401</a></td>
                                        </tr>
                                        <tr>
                                            <th class="text-black font-16">Manager Marketing:</th>
                                            <td><a class="theme-color" href="tel:+919374453247">+919374453247</a></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                    <div class="conatct-info-bottom h-100">
                        <div class="contact-header p-3">
                            <h5 class="division-heading fw-semibold text-uppercase mb-0">PURCHASE DEVISION</h5>
                        </div>
                        <div class="contact-body p-3">
                            <div class="table-responsive">
                                <table class="table table-borderless table-sm mb-0">
                                    <tbody>
                                        <tr>
                                            <th class="text-black font-16">Mechanical Director:</th>
                                            <td><a class="theme-color" href="tel:+919328850143">+919328850143</a></td>
                                        </tr>
                                        <tr>
                                            <th class="text-black font-16">Electrical Manager:</th>
                                            <td><a class="theme-color" href="tel:+919725013918">+919725013918</a></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                    <div class="conatct-info-bottom h-100">
                        <div class="contact-header p-3">
                            <h5 class="division-heading fw-semibold text-uppercase mb-0">FINANCE DEVISION</h5>
                        </div>
                        <div class="contact-body p-3">
                            <div class="table-responsive">
                                <table class="table table-borderless table-sm mb-0">
                                    <tbody>
                                        <tr>
                                            <th class="text-black font-16">Director :</th>
                                            <td><a class="theme-color" href="tel:+919427363268">+919427363268</a></td>
                                        </tr>
                                        <tr>
                                            <th class="text-black font-16">Account Officer:</th>
                                            <td><a class="theme-color" href="tel:+917929700170">+917929700170</a></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                    <div class="conatct-info-bottom h-100">
                        <div class="contact-header p-3">
                            <h5 class="division-heading fw-semibold text-uppercase mb-0">EMAIL ID'S</h5>
                        </div>
                        <div class="contact-body p-3">
                            <div class="table-responsive">
                                <table class="table table-borderless table-sm mb-0">
                                    <tbody>
                                        <tr>
                                            <th class="text-black font-16">Email 1:</th>
                                            <td>
                                                <a class="theme-color"
                                                    href="mailto:sales&#64;prismtextilemachinery.com">
                                                    sales&#64;prismtextilemachinery.com
                                                </a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="text-black font-16">Email 2:</th>
                                            <td>
                                                <a class="theme-color"
                                                    href="mailto:harshad&#64;prismtextilemachinery.com">
                                                    harshad&#64;prismtextilemachinery.com
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                    <div class="conatct-info-bottom h-100">
                        <div class="contact-header p-3">
                            <h5 class="division-heading fw-semibold text-uppercase mb-0">Working Hour's</h5>
                        </div>
                        <div class="contact-body p-3">
                            <div class="table-responsive">
                                <table class="table table-borderless table-sm mb-0">
                                    <tbody>
                                        <tr>
                                            <th class="text-black font-16">Monday - Saturday:</th>
                                            <td>9:00am to 06:00pm</td>
                                        </tr>
                                        <tr>
                                            <th class="text-black font-16">Sunday:</th>
                                            <td>Weekly Off</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <!-- ============Contact end  ======== -->
</div>
<!-- body wrapper end -->